module.exports = "/build/images/garbageIcon-gray.svg?206253014c128479e93cac83971b3e7d";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/garbageIcon-gray.svg
// module id = 1015
// module chunks = 0